import { render, staticRenderFns } from "./FileOptions.vue?vue&type=template&id=1a1a20b8&scoped=true&"
import script from "./FileOptions.vue?vue&type=script&lang=js&"
export * from "./FileOptions.vue?vue&type=script&lang=js&"
import style0 from "./FileOptions.vue?vue&type=style&index=0&id=1a1a20b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a20b8",
  null
  
)

export default component.exports